import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { ContextOne } from "contexts/ContextOne";
import ApiService from "services/ApiService";
import Spinner from "components/UI/Spinner";
import withAuth from "withAuth";

import "./User.scss";

const User = () => {
  const { uuid } = useParams();
  const { state: { loading }, dispatch } = useContext(ContextOne);

  const [user, setUser] = useState(null);

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });
    const user = await ApiService.getUser(uuid);
    setUser(user);
    dispatch({ type: "loading", val: false });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="user-component">
        <Spinner show={loading} />
        <div className="text-center">
          <div className="user-header">
            <div className="title">
              <h1>User</h1>
            </div>
          </div>
          <table className="table tbl-striped table-sm">
            <thead>
              <tr>
                <th>Username</th>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Status</th>
                <th>Admin?</th>
              </tr>
            </thead>
            <tbody>
              {user && (
                <tr key={user.uuid}>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.status}</td>
                  <td>{user.is_admin ? "Yes" : "No"}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default withAuth(User);
